import { css } from '@emotion/core';
import { shadow, tokens, variables } from '@domain-group/fe-brary';
var shadows = tokens.shadows,
  colors = tokens.colors;
export var submenu = {
  name: "73rvms",
  styles: "background-color:palegoldenrod;"
};
export var popUpMenu = /*#__PURE__*/css("position:absolute;box-shadow:", shadow(shadows.elevation4), ";border-radius:3px;background-color:", colors.neutral.surface.default, ";padding:8px 0;min-width:200px;z-index:", variables.global.layerPopout, ";");